import Toast from '@/components/Toast';

/**
 * 判空
 * @param {*} params 
 * @returns 
 */
export const isNull = (params: any) => {
  return params === '' || params === undefined || params === 'undefined' || params === null || params === 'null' || Object.keys(params).length === 0 || params.length === 0;
}

/**
 * 校验手机号
 * @param {*} str
 * @returns
 */
export const verifyChMobile = (str: string) => !/^1\d{10}$/.test(str);

/**
 * 国际手机号校验
 * @param {*} str
 * @returns
 */
export const validatINTMobile = (str: string) => !/^[1-9]\d{5,}$/.test(str);

/**
 * 邮箱格式校验
 * @param {*} str
 * @returns
 */
export const validatEmail = (str: string) => /^([a-zA-Z0-9+_-]+)(\.[a-zA-Z0-9+_-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/.test(str);

/**
 * 验证验证码
 * @param {*} code
 * @returns
 */
export const verifyCaptcha = (code: string) => {
  if (isNull(code) || code.length !== 6) {
    Toast('请正确输入验证码');
    return false;
  }
  return true;
};

/**
 * 验证手机号
 * @param {*} phoneNum
 * @returns
 */
export const verifyArg = (phoneNum: string, countryCode = '+86') => {
  if (isNull(phoneNum)) {
    Toast('请输入手机号码');
    return false;
  }
  if ((countryCode === '+86' && verifyChMobile(phoneNum)) || validatINTMobile(phoneNum)) {
    Toast('请输入正确手机号码');
    return false;
  }
  return true;
};

/**
 * 判断是否在妙投app里
 * @param {*} ua 
 */
export const isMiaotouApp = (ua: string) => !!ua.toLowerCase().match(/miaotouapp/gi);

/**
 * 判断是否在虎嗅app里
 */
export const isHuxiuApp = (ua: string) => !!ua.toLowerCase().match(/huxiuapp/gi);


/**
 * 判断是否为Android手机
 * @param {*} ua
 * @returns
 */
export const isAndroid = (ua: string) =>
  ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;


/**
 * 判断是否为ios手机
 * @param {*} ua
 * @returns
 */
export const isIos = (ua: string) => 
  !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

/**
 * 判断是否为ipad
 * @param {*} ua
 * @returns
 */
export const isIpad = (ua: string) => /ipad/i.test(ua.toLowerCase());

/**
 * 判断是否是微信平台
 * @param {*} ua
 * @returns
 */
export const isWeiXin = (ua: string) => {
  const matchObj = ua.toLowerCase().match(/MicroMessenger/i);
  if(matchObj && matchObj[0] === 'micromessenger'){
    return true;
  }
  return false
}

/**
 * js 与 ios 通信方法
 * @param {*} callback
 * @returns
 */
export const setupWebViewJavascriptBridge = (callback: any) => {
  if ((window as any).WebViewJavascriptBridge) {
    return callback((window as any).WebViewJavascriptBridge);
  }
  if ((window as any).WVJBCallbacks) {
    return (window as any).WVJBCallbacks.push(callback);
  }
  (window as any).WVJBCallbacks = [callback];
  let WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
};

/**
 * 格式化时间
 * @param time 
 * @param type 0  1  2  3 4 5 6
 * @returns 
 */
export function formatTime(time: number, type = 0) {
  const date = new Date(time)
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const weekDay = date.getDay();

  const hour = date.getHours();
  const minute = date.getMinutes();
  const sec = date.getSeconds();

  if (type === 1) {
    return [month, day].map(formatNumber).join('-') + ' ' + [hour, minute, sec].map(formatNumber).join(':'); // MM-DD hh:mm:ss
  } else if (type === 2) {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, sec].map(formatNumber).join(':'); // YY-MM-DD hh:mm:ss
  } else if (type === 3) {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':'); // YY-MM-DD hh:mm
  } else if (type === 4) {
    return [year, month, day].map(formatNumber).join('-'); // YY-MM-DD
  } else if (type === 5)  {
    return [hour, minute].map(formatNumber).join(':'); //  hh:mm
  } else if (type === 6) {
    const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    return weekDays[weekDay] + ' ' + [hour, minute].map(formatNumber).join(':'); // 星期几 + hh:mm
  } else if (type === 7) {
    return [hour, minute, sec].map(formatNumber).join(':'); //  hh:mm
  } else {
    return [month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':'); //  MM-DD hh:mm
  }
}

export function formatNumber(n: number) {
  const str = n.toString();
  return str[1] ? str : '0' + str;
}

/**
 * 时间格式统一为：
 * 当天为刚刚（小于10秒）、xx秒、xx分钟、xx小时前
 * 当年的为月-日
 * 跨年的为年-月-日
 */
export const getDateString = (timestamp: string) => {
  const timeLen = timestamp.length;
  const timestampNew = Number(timestamp);
  if (isNaN(timestampNew)) return '';

  const time = timeLen === 10 ? timestampNew * 1000 : timestampNew; // 接口给的时间

  const curTime = new Date().getTime(); // 当前时间
  const disTime = curTime - time;

  if (disTime > 0 && disTime < 10) { 
    return '刚刚';
  } else if (disTime > 0 && disTime < 60 * 1000) {
    return `${Math.trunc(disTime / 1000)}秒前`;
  } else if (disTime > 0 && disTime < 60 * 60 * 1000) {
    return `${Math.trunc(disTime / 60 / 1000)}分钟前`;
  } else if (disTime > 0 && disTime < 24 * 60 * 60 * 1000) {
    return `${Math.trunc(disTime / 60 / 60 / 1000)}小时前`;
  } else {
    const year = new Date(time).getFullYear();
    const curYear = new Date().getFullYear();
    if (year === curYear) return formatTime(time); 
    
    return formatTime(time, 3);
  }
}

/**
 * 防抖
 */
export const debounce = (fn: Function, delay = 200) => {
  // eslint-disable-next-line no-undef
  let timer: NodeJS.Timeout;
  return function () {
    const args = arguments;
    // @ts-ignore
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};

export const getNodeCookie = (cookie: string, key: string) => {
  if (cookie.length > 0) {
    let startIndex = cookie.indexOf(key + '=');

    if (startIndex !== -1) {
      startIndex = startIndex + key.length + 1;
      let endIndex = cookie.indexOf(';', startIndex);
      if (endIndex === -1) {
        endIndex = cookie.length;
      }
      return decodeURIComponent(
        cookie.substring(startIndex, endIndex)
      );
    }
  }
  return ''
}
/**
 * l浏览器端获取cookie
 */
export const getCookie = (key: string) => {
  if (document.cookie.length > 0) {
    let startIndex = document.cookie.indexOf(key + '=');

    if (startIndex !== -1) {
      startIndex = startIndex + key.length + 1;
      let endIndex = document.cookie.indexOf(';', startIndex);
      if (endIndex === -1) {
        endIndex = document.cookie.length;
      }
      return decodeURIComponent(
        document.cookie.substring(startIndex, endIndex)
      );
    }
  }
};

/**
 * 获取指定的响应头cookie的值
 */
export const getResponseSetCookieVal = (cookies: string[] | undefined, searchCookieKey: string) => {
  if (!cookies) return;
  const reg = new RegExp(searchCookieKey, 'ig');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    if (reg.test(cookie)){
      return getNodeCookie(cookie, searchCookieKey);
    }
  }
}

export const setCookie = (key: string, value: string) => {
  document.cookie = key + '=' + encodeURIComponent(value);
};

/**
 * 添加分页标识
 *  通过数据添加标识 dom循环时添加 class="js-more-flag"
 * @param order 正序还是倒序
 */
export const addLoadMoreFlag = (list: Array<any>, order: 'ascending' | 'descending') => {
  if (order === 'ascending') {
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if ((list.length >= 1 && list.length < 5 && list.length - 1 === i) || (list.length >= 5 && list.length - 5 === i)) {
        item.moreFlag = true;
        break;
      }
    }
  } else {
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if ((list.length >= 1 && list.length < 5 && i === 1) || (list.length >= 5 && i === 3)) {
        item.moreFlag = true;
        break;
      }
    }
  }
};

/**
 * 监测加载更多的标识
 *  来做分页处理
 * @param {*} list 做分页的list
 * @param {*} fn loadMore方法
 * @param {*} moreFlag 监听dom分页的标识 也就是需要监听到哪个dom出现在屏幕中，就出发分页方法
 */
export const loadMoreObserve = (list: Array<any>, fn: Function, moreFlag = 'js-more-flag') => {
  const targeDom = document.querySelectorAll(`.${moreFlag}`);
  if (targeDom.length <= 0) return;
  const curListenerDom = targeDom[0];

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        io.unobserve(curListenerDom);
        entry.target.classList.remove(moreFlag);
        list.forEach(item => {
          if (item.moreFlag) item.moreFlag = false;
        })
        fn();
      }
    })
  })

  io.observe(curListenerDom);
};


/**
 * app 主动调js 反色方法
 * @param setDarkMode 
 * @param cssObj 
 */
export const appDarkModeToggle = (setDarkMode: Function, cssObj: any) => {
  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.darkModeToggle_android = (type) => {
      if (type === 1) {
        setDarkMode(cssObj);
      } else {
        setDarkMode('');
      }
    }

    setupWebViewJavascriptBridge(function (bridge: any) {
      bridge.registerHandler('darkModeToggle', function (type: number) {
        if (type === 1) {
          setDarkMode(cssObj);
        } else {
          setDarkMode('');
        }
      });
    });
  }
}


/**
 * 指定的view滚动到指定位置
 * @param appointEl 指定view
 * @param top  指定位置
 */
export const appointElScrollTop = (dom: HTMLElement | null, options: globalThis.ScrollToOptions | undefined,  callback?: Function) => {
  if (!dom) return;

  dom.scrollTo(options);
  setTimeout(() => {
    callback && callback();  
  }, 500);
}

/**
 *  判断是否是开发环境
 */
export const isDev = (() => {
  if(process.env.NEXT_PUBLIC_ENV === 'development') {
    return true;
  }
  return false;
})()